import { createContext, useContext } from 'react';

interface FrameRangeValidationContextType {
  setFrameRangeError: (key: string, hasError: boolean) => void;
  hasAnyFrameRangeError: boolean;
}

export const FrameRangeValidationContext =
  createContext<FrameRangeValidationContextType>({
    setFrameRangeError: () => {},
    hasAnyFrameRangeError: false,
  });

export const useFrameRangeValidation = () =>
  useContext(FrameRangeValidationContext);
